import { useCallback, useEffect, useState } from 'react';
import BudgetCurrencyInput from '../BudgetCurrencyInput';

interface IBudgetCounterProposalMobileProps {
  counterProposal?: boolean;
  counterProposalValue?: number;
  counterProposalObs?: string;
  onCounterProposalValueChange?: (value: number) => void;
  onCounterProposalObsChange?: (value: string) => void;
  disabled?: boolean;
}

const BudgetCounterProposalMobile = (props: IBudgetCounterProposalMobileProps) => {
  const [observation, setObservation] = useState<string>(props.counterProposalObs || '');
  const [value, setValue] = useState<number>(props.counterProposalValue || 0);

  useEffect(() => {
    setObservation(props.counterProposalObs || '');
  }, [props.counterProposalObs]);

  useEffect(() => {
    setValue(props.counterProposalValue || 0);
  }, [props.counterProposalValue]);

  const handleObservationChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const newValue = e.target.value;
      setObservation(newValue);
      props.onCounterProposalObsChange?.(newValue);
    },
    [props],
  );

  const handleValueChange = useCallback(
    (newValue: number) => {
      setValue(newValue);
      props.onCounterProposalValueChange?.(newValue);
    },
    [props],
  );

  return (
    <div className="m-3 px-2 border-2 border-gray-100 dark:border-neutral-700 rounded-md p-3">
      <div className="flex flex-row items-center mb-4">
        <div className="font-bold text-size-12 text-gray-700 dark:text-neutral-300">Contraproposta</div>
      </div>

      <div className="flex flex-col gap-4">
        <div className="flex-1">
          <div className="font-bold mb-2 text-size-12 text-gray-500 dark:text-neutral-400">Observação</div>
          <textarea
            className="form-control w-full"
            rows={1}
            placeholder="Insira um texto em caso de contraproposta"
            value={observation}
            onChange={handleObservationChange}
            disabled={props.disabled}
          />
        </div>

        <div className="w-full">
          <div className="font-bold mb-2 text-size-12 text-gray-500 dark:text-neutral-400">Valor da contraproposta</div>
          <BudgetCurrencyInput value={value} onChange={handleValueChange} placeholder="R$ 0,00" disabled={props.disabled} />
        </div>
      </div>
    </div>
  );
};

export default BudgetCounterProposalMobile;
